import { scrollToEl } from '../lib/lenis';

// Links to #intercom ("יש לי שאלה", "צור קשר") open the Intercom messenger.
//
// The widget only exists once an App ID is set in the Intercom plugin; the
// snippet's stub is on the window either way, so readiness is judged by the App
// ID and not by the function. Without one the click would do nothing at all, so
// it falls back to the FAQ section when the page has one.
const TRIGGER_HASH = 'intercom';
const FALLBACK_ID = 'faq';
const NAV_OFFSET = -100;

function hashOf(link: HTMLAnchorElement): string {
  const href = link.getAttribute('href') || '';
  if (href.startsWith('#')) return href.slice(1);

  try {
    return new URL(link.href, window.location.href).hash.slice(1);
  } catch {
    return '';
  }
}

function messengerReady(): boolean {
  return typeof window.Intercom === 'function' && !!window.intercomSettings?.app_id;
}

export function initIntercom(): void {
  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

      const link = (event.target as HTMLElement | null)?.closest?.<HTMLAnchorElement>('a[href]');
      if (!link || link.target === '_blank' || hashOf(link) !== TRIGGER_HASH) return;

      if (messengerReady()) {
        event.preventDefault();
        window.Intercom?.('show');
        return;
      }

      const fallback = document.getElementById(FALLBACK_ID);
      if (fallback) {
        event.preventDefault();
        scrollToEl(fallback, NAV_OFFSET);
      }
    },
    { capture: true },
  );
}
